import React, { useState, useEffect } from "react";
import {
  Breadcrumb,
  Button,
  Col,
  Container,
  Form,
  Row,
  Tab,
  Nav,
} from "react-bootstrap";
import { getFinanceById } from "../../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../../Common/extra/loading";
import { useParams } from "react-router-dom";
import PersonalInfo from "./components/personalInfo";
import EmploymentInfo from "./components/EmploymentInfo";
import OtherFinancialInfo from "./components/OtherFinancialInfo";
import PersonalAssets from "./components/PersonalAssets";
import RealPropertyOwned from "./components/RealPropertyOwned";
import Vehicles from "./components/Vehicles";
import IncomeExpenseStatement from "./components/IncomeExpenseStatement";
import Assets from "./components/Assets";
import {
  PDFDownloadLink,
  Document,
  Page,
  Text,
  View,
  StyleSheet,
} from "@react-pdf/renderer";
import LeagalInfo from "./components/Leagal";
import BankruptcyInfo from "./components/Bankruptcy";

const ViewFinanceFormIndex = () => {
  const { editId } = useParams();
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("personalInfo");
  const [data, setData] = useState({
    name: "",
    documents: [],
    template_categories_id: "",
    template_categories_name: "",
  });
  const MessageData = useSelector((s) => s.Signatures?.finance?.data);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };
  useEffect(() => {
    dispatch(getFinanceById(editId));
  }, [editId]);

  const styles = StyleSheet.create({
    page: {
      flexDirection: "row",
      backgroundColor: "#f0f0f0",
    },
    section: {
      margin: 10,
      padding: 10,
      flexGrow: 1,
      display: "flex",
    },
    heading: {
      fontSize: 18,
      fontWeight: "bold",
      marginBottom: 10,
      textAlign: "center",
      backgroundColor: "#605b5bbf",
      color: "#fff",
      padding: "3px 0",
    },
    subHeading: {
      fontSize: 16,
      fontWeight: "bold",
      marginBottom: 10,
      marginTop: 20,
    },
    content: {
      fontSize: 12,
      fontFamily: "Helvetica",
    },
    allFields: {
      padding: "5px 0 5px 0",
      fontSize: 12,
    },
  });
  const MyDoc = (id) => (
    <Document>
      <Page>
        <View style={styles.section}>
          <Text style={styles.heading}>Personal Info</Text>
          <Text style={styles.allFields}>
            Full Name:{" "}
            {(MessageData && MessageData?.personal_information?.full_name) ||
              "--"}
          </Text>
          <Text style={styles.allFields}>
            Marital Status:{" "}
            {(MessageData &&
              MessageData?.personal_information?.marital_status) ||
              "--"}
          </Text>
          <Text style={styles.allFields}>
            Address:{" "}
            {(MessageData && MessageData?.personal_information?.address) ||
              "--"}
          </Text>
          <Text style={styles.allFields}>
            Cell Phone:{" "}
            {(MessageData &&
              "+" + MessageData?.personal_information?.cell_phone) ||
              "--"}
          </Text>
          <Text style={styles.allFields}>
            Work Phone:{" "}
            {(MessageData &&
              "+" + MessageData?.personal_information?.work_phone) ||
              "--"}
          </Text>
          <Text style={styles.allFields}>
            Home Phone:{" "}
            {(MessageData &&
              "+" + MessageData?.personal_information?.home_phone) ||
              "--"}
          </Text>
          <Text style={styles.allFields}>
            Email:{" "}
            {(MessageData && MessageData?.personal_information?.email) || "--"}
          </Text>
          <Text style={styles.allFields}>
            Fax:{" "}
            {(MessageData && MessageData?.personal_information?.fax) || "--"}
          </Text>
          <Text style={styles.allFields}>
            SSN:{" "}
            {(MessageData &&
              MessageData?.personal_information?.social_security_no) ||
              "--"}
          </Text>
          <Text style={styles.allFields}>
            DOB:{" "}
            {(MessageData &&
              MessageData?.personal_information?.date_of_birth) ||
              "--"}
          </Text>
          <Text style={styles.subHeading}>Dependents</Text>
          <Text style={styles.allFields}>
            Name:{" "}
            {(MessageData &&
              MessageData?.personal_information?.dependents?.name) ||
              "--"}
          </Text>
          <Text style={styles.allFields}>
            Age:{" "}
            {(MessageData &&
              MessageData?.personal_information?.dependents?.age) ||
              "--"}
          </Text>
          <Text style={styles.allFields}>
            Relationship:{" "}
            {(MessageData &&
              MessageData?.personal_information?.dependents?.relationship) ||
              "--"}
          </Text>
        </View>
        <View style={styles.section}>
          <Text style={styles.heading}>Employment Info</Text>
          <Text style={styles.allFields}>
            Employer: {MessageData?.employment_information?.employer || "--"}
          </Text>
          <Text style={styles.allFields}>
            Length on Job:{" "}
            {MessageData?.employment_information?.length_of_job || "--"}
          </Text>
          <Text style={styles.allFields}>
            Employer Address:{" "}
            {MessageData?.employment_information?.employer_address || "--"}
          </Text>
          <Text style={styles.allFields}>
            Occupation:{" "}
            {MessageData?.employment_information?.occupation || "--"}
          </Text>
          <Text style={styles.allFields}>
            Pay Period:{" "}
            {MessageData?.employment_information?.pay_period || "--"}
          </Text>
          <Text style={styles.subHeading}>For Spouse</Text>
          <Text style={styles.allFields}>
            Employer:{" "}
            {MessageData?.employment_information?.for_spouse?.employer || "--"}
          </Text>
          <Text style={styles.allFields}>
            Length on Job:{" "}
            {MessageData?.employment_information?.for_spouse?.length_of_job ||
              "--"}
          </Text>
          <Text style={styles.allFields}>
            Employer Address:{" "}
            {MessageData?.employment_information?.for_spouse
              ?.employer_address || "--"}
          </Text>
          <Text style={styles.allFields}>
            Occupation:{" "}
            {MessageData?.employment_information?.for_spouse?.occupation ||
              "--"}
          </Text>
          <Text style={styles.allFields}>
            Pay Period:{" "}
            {MessageData?.employment_information?.for_spouse?.pay_period ||
              "--"}
          </Text>
        </View>
      </Page>
      <Page>
        <View style={styles.section}>
          <Text style={styles.heading}>Other Financial Info</Text>
          <Text style={styles.allFields}>
            Are you currently a party to lawsuit:{" "}
            {MessageData?.other_finanical_information
              ?.are_you_currently_a_party_to_law_suit || "--"}
          </Text>
          <Text style={styles.allFields}>
            Plaintiff or Defendent:{" "}
            {MessageData?.other_finanical_information?.law_suit_yes
              ?.plaintiff_defendent || "--"}
          </Text>
          <Text style={styles.allFields}>
            Location of filing:{" "}
            {MessageData?.other_finanical_information?.law_suit_yes
              ?.location_of_filing || "--"}
          </Text>
          <Text style={styles.allFields}>
            Case No.:{" "}
            {MessageData?.other_finanical_information?.law_suit_yes?.case_no ||
              "--"}
          </Text>
          <Text style={styles.allFields}>
            Subject of suit:{" "}
            {MessageData?.other_finanical_information?.law_suit_yes
              ?.subject_of_suit || "--"}
          </Text>
          <Text style={styles.allFields}>
            filed for bankrupty protection:{" "}
            {MessageData?.other_finanical_information
              ?.have_you_ever_filed_for_bankcrupty_protection || "--"}
          </Text>
          <Text style={styles.allFields}>
            Date of filing:{" "}
            {MessageData?.other_finanical_information?.bankcrupty_protection_yes
              ?.date_of_filing || "--"}
          </Text>
          <Text style={styles.allFields}>
            Date of Discharge:{" "}
            {MessageData?.other_finanical_information?.bankcrupty_protection_yes
              ?.date_of_discharge || "--"}
          </Text>
          <Text style={styles.allFields}>
            Petition No:{" "}
            {MessageData?.other_finanical_information?.bankcrupty_protection_yes
              ?.petition_no || "--"}
          </Text>
          <Text style={styles.allFields}>
            Location:{" "}
            {MessageData?.other_finanical_information?.bankcrupty_protection_yes
              ?.location || "--"}
          </Text>
          <Text style={styles.allFields}>
            Any increase/decrease in income:{" "}
            {MessageData?.other_finanical_information
              ?.increase_decrease_in_income || "--"}
          </Text>
          <Text style={styles.allFields}>
            Are you Beneficiary to any trust,estate or life insurance:
            {MessageData?.other_finanical_information
              ?.beneficiary_to_any_trust_estate_life_insurance || " --"}
          </Text>
        </View>
        <View style={styles.section}>
          <Text style={styles.heading}>Personal Assets</Text>
          <Text style={styles.allFields}>
            Cash on hand: {MessageData?.personal_assets?.cash_on_hand || "--"}
          </Text>
          <Text style={styles.subHeading}>Personal Bank Account</Text>

          <Text style={styles.allFields}>
            Full Name of bank:{" "}
            {MessageData?.personal_assets?.personal_bank_account?.fullname ||
              "--"}
          </Text>
          <Text style={styles.allFields}>
            Address of bank:{" "}
            {MessageData?.personal_assets?.personal_bank_account
              ?.address_of_bank || "--"}
          </Text>
          <Text style={styles.allFields}>
            Account Type:{" "}
            {MessageData?.personal_assets?.personal_bank_account
              ?.account_type || "--"}
          </Text>
          <Text style={styles.allFields}>
            Account Number:{" "}
            {MessageData?.personal_assets?.personal_bank_account
              ?.account_number || "--"}
          </Text>
          <Text style={styles.allFields}>
            Account Balance:{" "}
            {MessageData?.personal_assets?.personal_bank_account
              ?.account_balance || "--"}
          </Text>

          <Text style={styles.subHeading}>Additional Bank Account</Text>

          <Text style={styles.allFields}>
            Full Name of bank:{" "}
            {MessageData?.personal_assets?.additional_bank_account?.fullname ||
              "--"}
          </Text>
          <Text style={styles.allFields}>
            Address of bank:{" "}
            {MessageData?.personal_assets?.additional_bank_account
              ?.address_of_bank || "--"}
          </Text>
          <Text style={styles.allFields}>
            Account Type:{" "}
            {MessageData?.personal_assets?.additional_bank_account
              ?.account_type || "--"}
          </Text>
          <Text style={styles.allFields}>
            Account Number:{" "}
            {MessageData?.personal_assets?.additional_bank_account
              ?.account_number || "--"}
          </Text>
          <Text style={styles.allFields}>
            Account Balance:{" "}
            {MessageData?.personal_assets?.additional_bank_account
              ?.account_balance || "--"}
          </Text>

          <Text style={styles.subHeading}>Credit Account</Text>

          <Text style={styles.allFields}>
            Full Name of bank:{" "}
            {MessageData?.personal_assets?.credit_accounts?.fullname || "--"}
          </Text>
          <Text style={styles.allFields}>
            Address of bank:{" "}
            {MessageData?.personal_assets?.credit_accounts?.address_of_bank ||
              "--"}
          </Text>
          <Text style={styles.allFields}>
            Account Type:{" "}
            {MessageData?.personal_assets?.credit_accounts?.account_type ||
              "--"}
          </Text>
          <Text style={styles.allFields}>
            Account Number:{" "}
            {MessageData?.personal_assets?.credit_accounts?.account_number ||
              "--"}
          </Text>
          <Text style={styles.allFields}>
            Account Balance:{" "}
            {MessageData?.personal_assets?.credit_accounts?.account_balance ||
              "--"}
          </Text>
        </View>
        <View style={styles.section}>
          <Text style={styles.subHeading}>Investments</Text>
          <Text style={styles.allFields}>
            Investment Type:{" "}
            {MessageData?.personal_assets?.investment?.type || "--"}
          </Text>
          <Text style={styles.allFields}>
            Full name of institution:{" "}
            {MessageData?.personal_assets?.investment?.fullname || "--"}
          </Text>
          <Text style={styles.allFields}>
            Address of institution:{" "}
            {MessageData?.personal_assets?.investment?.address_of_institution ||
              "--"}
          </Text>
          <Text style={styles.allFields}>
            Account Number:{" "}
            {MessageData?.personal_assets?.investment?.account_number || "--"}
          </Text>
          <Text style={styles.allFields}>
            Account Balance:{" "}
            {MessageData?.personal_assets?.investment?.account_balance || "--"}
          </Text>
          <Text style={styles.allFields}>
            Whole life insurance:{" "}
            {MessageData?.personal_assets?.whole_life_insurance || "--"}
          </Text>
        </View>
        <View style={styles.section}>
          <Text style={styles.heading}>Real Property Owned</Text>
          <Text style={styles.allFields}>
            Property Description:{" "}
            {MessageData?.real_property_owned?.property_description || "--"}
          </Text>
          <Text style={styles.allFields}>
            Location: {MessageData?.real_property_owned?.location || "--"}
          </Text>
          <Text style={styles.allFields}>
            Current market fair value:{" "}
            {MessageData?.real_property_owned?.current_fair_market_value ||
              "--"}
          </Text>
          <Text style={styles.allFields}>
            Loan balance:{" "}
            {MessageData?.real_property_owned?.loan_balance || "--"}
          </Text>
          <Text style={styles.allFields}>
            Amount of monthly payment:{" "}
            {MessageData?.real_property_owned?.amount_of_monthly_payment ||
              "--"}
          </Text>
          <Text style={styles.allFields}>
            Amount of your equity:{" "}
            {MessageData?.real_property_owned?.amount_of_your_equity || "--"}
          </Text>
          <Text style={styles.allFields}>
            Name of lender:{" "}
            {MessageData?.real_property_owned?.name_of_lender || "--"}
          </Text>
          <Text style={styles.allFields}>
            Address of lender:{" "}
            {MessageData?.real_property_owned?.address || "--"}
          </Text>
          <Text style={styles.allFields}>
            Account Number:{" "}
            {MessageData?.real_property_owned?.account_no || "--"}
          </Text>
        </View>
        <View style={styles.section}>
          <Text style={styles.heading}>Vehicles</Text>
          <Text style={styles.allFields}>
            Vehicle year: {MessageData?.vehicles?.year || "--"}
          </Text>
          <Text style={styles.allFields}>
            Vehicle make: {MessageData?.vehicles?.make || "--"}
          </Text>
          <Text style={styles.allFields}>
            Vehicle model: {MessageData?.vehicles?.model || "--"}
          </Text>
          <Text style={styles.allFields}>
            Vehicle mileage: {MessageData?.vehicles?.mileage || "--"}
          </Text>
          <Text style={styles.allFields}>
            Purchase/Lease date:{" "}
            {MessageData?.vehicles?.purchase_lease_date || "--"}
          </Text>
          <Text style={styles.allFields}>
            Current market value:{" "}
            {MessageData?.vehicles?.cutrrent_market_value || "--"}
          </Text>
          <Text style={styles.allFields}>
            Amount owned: {MessageData?.vehicles?.amount_owned || "--"}
          </Text>
          <Text style={styles.allFields}>
            Monthly payment: {MessageData?.vehicles?.monthly_payment || "--"}
          </Text>
          <Text style={styles.allFields}>
            Name of lender/lesser: {MessageData?.vehicles?.name || "--"}
          </Text>
          <Text style={styles.allFields}>
            Address of lender/lesser: {MessageData?.vehicles?.address || "--"}
          </Text>
          <Text style={styles.allFields}>
            Phone No of lender/lesser:{" "}
            {MessageData?.vehicles?.phone_of_lender_lessor || "--"}
          </Text>
        </View>
        <View style={styles.section}>
          <Text style={styles.subHeading}>Another Vehicle Description</Text>

          <Text style={styles.allFields}>
            Vehicle year:{" "}
            {MessageData?.another_vehicle_description?.year || "--"}
          </Text>
          <Text style={styles.allFields}>
            Vehicle make:{" "}
            {MessageData?.another_vehicle_description?.make || "--"}
          </Text>
          <Text style={styles.allFields}>
            Vehicle model:{" "}
            {MessageData?.another_vehicle_description?.model || "--"}
          </Text>
          <Text style={styles.allFields}>
            Vehicle mileage:{" "}
            {MessageData?.another_vehicle_description?.mileage || "--"}
          </Text>
          <Text style={styles.allFields}>
            Purchase/Lease date:{" "}
            {MessageData?.another_vehicle_description?.purchase_lease_date ||
              "--"}
          </Text>
          <Text style={styles.allFields}>
            Current market value:{" "}
            {MessageData?.another_vehicle_description?.cutrrent_market_value ||
              "--"}
          </Text>
          <Text style={styles.allFields}>
            Amount owned:{" "}
            {MessageData?.another_vehicle_description?.amount_owned || "--"}
          </Text>
          <Text style={styles.allFields}>
            Monthly payment:{" "}
            {MessageData?.another_vehicle_description?.monthly_payment || "--"}
          </Text>
          <Text style={styles.allFields}>
            Name of lender/lesser:{" "}
            {MessageData?.another_vehicle_description?.name || "--"}
          </Text>
          <Text style={styles.allFields}>
            Address of lender/lesser:{" "}
            {MessageData?.another_vehicle_description?.address || "--"}
          </Text>
          <Text style={styles.allFields}>
            Phone No of lender/lesser:{" "}
            {MessageData?.another_vehicle_description?.phone_of_lender_lessor ||
              "--"}
          </Text>
        </View>
        <View style={styles.section}>
          <Text style={styles.heading}>Assets</Text>

          <Text style={styles.subHeading}>Furniture</Text>
          <Text style={styles.allFields}>
            Location: {MessageData?.assets?.furniture?.location || "--"}
          </Text>
          <Text style={styles.allFields}>
            Value: {MessageData?.assets?.furniture?.value || "--"}
          </Text>
          <Text style={styles.allFields}>
            Loan Balance: {MessageData?.assets?.furniture?.loanbalance || "--"}
          </Text>

          <Text style={styles.subHeading}>Personal Effects</Text>
          <Text style={styles.allFields}>
            Location: {MessageData?.assets?.personal_effects?.location || "--"}
          </Text>
          <Text style={styles.allFields}>
            Value: {MessageData?.assets?.personal_effects?.value || "--"}
          </Text>
          <Text style={styles.allFields}>
            Loan Balance:{" "}
            {MessageData?.assets?.personal_effects?.loanbalance || "--"}
          </Text>

          <Text style={styles.subHeading}>Artwork</Text>
          <Text style={styles.allFields}>
            Location: {MessageData?.assets?.artwork?.location || "--"}
          </Text>
          <Text style={styles.allFields}>
            Value: {MessageData?.assets?.artwork?.value || "--"}
          </Text>
          <Text style={styles.allFields}>
            Loan Balance: {MessageData?.assets?.artwork?.loanbalance || "--"}
          </Text>

          <Text style={styles.subHeading}>Jewellery</Text>
          <Text style={styles.allFields}>
            Location: {MessageData?.assets?.jewellery?.location || "--"}
          </Text>
          <Text style={styles.allFields}>
            Value: {MessageData?.assets?.jewellery?.value || "--"}
          </Text>
          <Text style={styles.allFields}>
            Loan Balance: {MessageData?.assets?.jewellery?.loanbalance || "--"}
          </Text>

          <Text style={styles.subHeading}>Collections</Text>
          <Text style={styles.allFields}>
            Location: {MessageData?.assets?.collections?.location || "--"}
          </Text>
          <Text style={styles.allFields}>
            Value: {MessageData?.assets?.collections?.value || "--"}
          </Text>
          <Text style={styles.allFields}>
            Loan Balance:{" "}
            {MessageData?.assets?.collections?.loanbalance || "--"}
          </Text>

          <Text style={styles.subHeading}>Guns</Text>
          <Text style={styles.allFields}>
            Location: {MessageData?.assets?.guns?.location || "--"}
          </Text>
          <Text style={styles.allFields}>
            Value: {MessageData?.assets?.guns?.value || "--"}
          </Text>
          <Text style={styles.allFields}>
            Loan Balance: {MessageData?.assets?.guns?.loanbalance || "--"}
          </Text>

          <Text style={styles.subHeading}>Coins</Text>
          <Text style={styles.allFields}>
            Location: {MessageData?.assets?.coins?.location || "--"}
          </Text>
          <Text style={styles.allFields}>
            Value: {MessageData?.assets?.coins?.value || "--"}
          </Text>
          <Text style={styles.allFields}>
            Loan Balance: {MessageData?.assets?.coins?.loanbalance || "--"}
          </Text>

          <Text style={styles.subHeading}>Antiques</Text>
          <Text style={styles.allFields}>
            Location: {MessageData?.assets?.antiques?.location || "--"}
          </Text>
          <Text style={styles.allFields}>
            Value: {MessageData?.assets?.antiques?.value || "--"}
          </Text>
          <Text style={styles.allFields}>
            Loan Balance: {MessageData?.assets?.antiques?.loanbalance || "--"}
          </Text>
        </View>

        <View style={styles.section}>
          <Text style={styles.heading}>Income Statement</Text>

          <Text style={styles.subHeading}>Gross Income</Text>
          <Text style={styles.allFields}>
            You: {MessageData?.income?.gross_income?.you || "--"}
          </Text>
          <Text style={styles.allFields}>
            Spouse: {MessageData?.income?.gross_income?.spouse_partner}
          </Text>

          <Text style={styles.subHeading}>Rent Income</Text>
          <Text style={styles.allFields}>
            You: {MessageData?.income?.rent_income?.you || "--"}
          </Text>
          <Text style={styles.allFields}>
            Spouse: {MessageData?.income?.rent_income?.spouse_partner}
          </Text>

          <Text style={styles.subHeading}>Other Income</Text>
          <Text style={styles.allFields}>
            You: {MessageData?.income?.other_income?.you || "--"}
          </Text>
          <Text style={styles.allFields}>
            Spouse: {MessageData?.income?.other_income?.spouse_partner}
          </Text>

          <Text style={styles.subHeading}>Child Support</Text>
          <Text style={styles.allFields}>
            You: {MessageData?.income?.child_support?.you || "--"}
          </Text>
          <Text style={styles.allFields}>
            Spouse: {MessageData?.income?.child_support?.spouse_partner}
          </Text>

          <Text style={styles.subHeading}>Soc, Sec, SSI</Text>
          <Text style={styles.allFields}>
            You: {MessageData?.income?.soc_sec_ssi?.you || "--"}
          </Text>
          <Text style={styles.allFields}>
            Spouse: {MessageData?.income?.soc_sec_ssi?.spouse_partner}
          </Text>

          <Text style={styles.subHeading}>Pension</Text>
          <Text style={styles.allFields}>
            You: {MessageData?.income?.pension?.you || "--"}
          </Text>
          <Text style={styles.allFields}>
            Spouse: {MessageData?.income?.pension?.spouse_partner || "--"}
          </Text>

          <Text style={styles.subHeading}>Other/Misc</Text>
          <Text style={styles.allFields}>
            You: {MessageData?.income?.other_misc?.you || "--"}
          </Text>
          <Text style={styles.allFields}>
            Spouse: {MessageData?.income?.other_misc?.spouse_partner || "--"}
          </Text>
        </View>

        <View style={styles.section}>
          <Text style={styles.heading}>Expense Statement</Text>
          <Text style={styles.subHeading}>Debt (Monthly)</Text>

          <Text style={styles.allFields}>
            Primary Home Mortgage:{" "}
            {MessageData?.expenses?.primary_home_mortgage || "--"}
          </Text>
          <Text style={styles.allFields}>
            Personal loan: {MessageData?.expenses?.personal_loans || "--"}
          </Text>
          <Text style={styles.allFields}>
            Primary home tax & ins.:{" "}
            {MessageData?.expenses?.primary_home_tax_ins || "--"}
          </Text>

          <Text style={styles.allFields}>
            Income taxes (from paycheck):{" "}
            {MessageData?.expenses?.income_tax_from_paycheck || "--"}
          </Text>
          <Text style={styles.allFields}>
            Any other mortgages:{" "}
            {MessageData?.expenses?.any_other_mortgage || "--"}
          </Text>
          <Text style={styles.allFields}>
            401kLoans: {MessageData?.expenses?.fourZeroOneKLoans || "--"}
          </Text>

          <Text style={styles.allFields}>
            Any other property tax/ins.:{" "}
            {MessageData?.expenses?.any_other_property_tax_ins || "--"}
          </Text>
          <Text style={styles.allFields}>
            Child Support: {MessageData?.expenses?.child_support || "--"}
          </Text>
          <Text style={styles.allFields}>
            Credit card payments (total):{" "}
            {MessageData?.expenses?.credit_card_payments_total || "--"}
          </Text>

          <Text style={styles.allFields}>
            Alimony: {MessageData?.expenses?.alimony || "--"}
          </Text>
          <Text style={styles.allFields}>
            Any other revolving debt:{" "}
            {MessageData?.expenses?.any_other_revolving_debt || "--"}
          </Text>
          <Text style={styles.allFields}>
            IRS liens: {MessageData?.expenses?.irs_liens || "--"}
          </Text>

          <Text style={styles.allFields}>
            Installment loan payments:{" "}
            {MessageData?.expenses?.installment_loan_payments || "--"}
          </Text>
          <Text style={styles.allFields}>
            Tuition: {MessageData?.expenses?.tuition || "--"}
          </Text>
          <Text style={styles.allFields}>
            Dependent/Child care:{" "}
            {MessageData?.expenses?.dependent_child_care || "--"}
          </Text>
          <Text style={styles.allFields}>
            Student loans: {MessageData?.expenses?.student_loans || "--"}
          </Text>

          <Text style={styles.subHeading}>Insurance (Monthly)</Text>
          <Text style={styles.allFields}>
            Medical: {MessageData?.expenses_insurance?.medical?.amount || "--"}
          </Text>
          <Text style={styles.allFields}>
            Is this dedcuted from paycheck:{" "}
            {MessageData?.expenses_insurance?.medical?.is_paycheck || "--"}
          </Text>

          <Text style={styles.allFields}>
            Vision: {MessageData?.expenses_insurance?.vision?.amount || "--"}
          </Text>
          <Text style={styles.allFields}>
            Is this dedcuted from paycheck:{" "}
            {MessageData?.expenses_insurance?.vision?.is_paycheck || "--"}
          </Text>

          <Text style={styles.allFields}>
            Dental: {MessageData?.expenses_insurance?.dental?.amount || "--"}
          </Text>
          <Text style={styles.allFields}>
            Is this dedcuted from paycheck:{" "}
            {MessageData?.expenses_insurance?.dental?.is_paycheck || "--"}
          </Text>

          <Text style={styles.allFields}>
            Disability:{" "}
            {MessageData?.expenses_insurance?.disability?.amount || "--"}
          </Text>
          <Text style={styles.allFields}>
            Is this dedcuted from paycheck:{" "}
            {MessageData?.expenses_insurance?.disability?.is_paycheck || "--"}
          </Text>

          <Text style={styles.allFields}>
            Life: {MessageData?.expenses_insurance?.life?.amount || "--"}
          </Text>
          <Text style={styles.allFields}>
            Is this dedcuted from paycheck:{" "}
            {MessageData?.expenses_insurance?.life?.is_paycheck || "--"}
          </Text>

          <Text style={styles.allFields}>
            Surrender Value:{" "}
            {MessageData?.expenses_insurance?.surrender_value?.amount || "--"}
          </Text>
          <Text style={styles.allFields}>
            Is this dedcuted from paycheck:{" "}
            {MessageData?.expenses_insurance?.surrender_value?.is_paycheck ||
              "--"}
          </Text>
        </View>
        <View style={styles.section}>
          <Text style={styles.subHeading}>Utilities (Monthly)</Text>

          <Text style={styles.allFields}>
            Gas Expense: {MessageData?.expenses?.gas || "--"}
          </Text>
          <Text style={styles.allFields}>
            Vehicle Insurance:{" "}
            {MessageData?.expenses?.vehicle_insurance || "--"}
          </Text>
          <Text style={styles.allFields}>
            Electric Expense: {MessageData?.expenses?.electric || "--"}
          </Text>

          <Text style={styles.allFields}>
            Water Expense: {MessageData?.expenses?.water || "--"}
          </Text>
          <Text style={styles.allFields}>
            Maintenance Expense: {MessageData?.expenses?.maintenance || "--"}
          </Text>
          <Text style={styles.allFields}>
            Trash/sewer Expense: {MessageData?.expenses?.trash_sewer || "--"}
          </Text>

          <Text style={styles.allFields}>
            Telephone Expense: {MessageData?.expenses?.telephone || "--"}
          </Text>
          <Text style={styles.allFields}>
            Cellphone Expense: {MessageData?.expenses?.cell_phone || "--"}
          </Text>
          <Text style={styles.allFields}>
            Internet Expense: {MessageData?.expenses?.internet || "--"}
          </Text>

          <Text style={styles.allFields}>
            Cable/satellite TV Expense:{" "}
            {MessageData?.expenses?.cable_satellite || "--"}
          </Text>

          <Text style={styles.subHeading}>Other Living Expense</Text>
          <Text style={styles.allFields}>
            Food Expense: {MessageData?.expenses?.food || "--"}
          </Text>
          <Text style={styles.allFields}>
            Gardening/landscaping Expense:{" "}
            {MessageData?.expenses?.gardening_landscaping || "--"}
          </Text>
          <Text style={styles.allFields}>
            Transportation Expense:{" "}
            {MessageData?.expenses?.transportation || "--"}
          </Text>
          <Text style={styles.allFields}>
            House cleaning Expense:{" "}
            {MessageData?.expenses?.housecleaning || "--"}
          </Text>
          <Text style={styles.allFields}>
            Other Expense: {MessageData?.expenses?.other || "--"}
          </Text>
        </View>
      </Page>
      <Page>
        <View style={styles.section}>
          <Text style={styles.subHeading}>Other Living Expense</Text>
          <Text style={styles.allFields}>
            Food Expense: {MessageData?.expenses?.food || "--"}
          </Text>
          <Text style={styles.allFields}>
            Gardening/landscaping Expense:{" "}
            {MessageData?.expenses?.gardening_landscaping || "--"}
          </Text>
          <Text style={styles.allFields}>
            Transportation Expense:{" "}
            {MessageData?.expenses?.transportation || "--"}
          </Text>
          <Text style={styles.allFields}>
            House cleaning Expense:{" "}
            {MessageData?.expenses?.housecleaning || "--"}
          </Text>
          <Text style={styles.allFields}>
            Other Expense: {MessageData?.expenses?.other || "--"}
          </Text>
        </View>
      </Page>
    </Document>
  );
  return (
    <>
      <section className="dashboard profile-main py-2">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div className="top mb-2">
                <Breadcrumb>
                  <Breadcrumb.Item href="/financial-form">
                    Financial Questionnaire
                  </Breadcrumb.Item>
                  <Breadcrumb.Item active>Details</Breadcrumb.Item>
                </Breadcrumb>
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg="12" className="my-2 text-end">
              <PDFDownloadLink
                className="common-btn d-inline-flex align-items-center justify-content-center text-white"
                document={<MyDoc />}
                fileName="finance.pdf"
              >
                {({ blob, url, loading, error }) =>
                  loading ? "Loading document..." : "Export as PDF"
                }
              </PDFDownloadLink>
            </Col>
            <Col lg="12" className="my-2">
              <Tab.Container id="left-tabs-example">
                <div className="">
                  <Nav
                    variant="pills"
                    className="bg-white mb-3 commonTabs commonfinanceTabs viewprofile"
                  >
                    <Nav.Item>
                      <Nav.Link
                        className={`bg-transparent border-0 py-3 position-relative px-3 ${
                          activeTab == "personalInfo" && "active"
                        }`}
                        onClick={() => handleTabChange("personalInfo")}
                      >
                        Personal Information
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        className={`bg-transparent border-0 py-3 position-relative px-3 ${
                          activeTab == "empInfo" && "active"
                        }`}
                        onClick={() => handleTabChange("empInfo")}
                      >
                        Employment Information
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        className={`bg-transparent border-0 py-3 position-relative px-3 ${
                          activeTab == "otherFinancialInfo" && "active"
                        }`}
                        onClick={() => handleTabChange("otherFinancialInfo")}
                      >
                        Other Financial Information
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        className={`bg-transparent border-0 py-3 position-relative px-3 ${
                          activeTab == "personalAssets" && "active"
                        }`}
                        onClick={() => handleTabChange("personalAssets")}
                      >
                        Personal Assets
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        className={`bg-transparent border-0 py-3 position-relative px-3 ${
                          activeTab == "realPropertyOwned" && "active"
                        }`}
                        onClick={() => handleTabChange("realPropertyOwned")}
                      >
                        Real Property Owned
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        className={`bg-transparent border-0 py-3 position-relative px-3 ${
                          activeTab == "vehicles" && "active"
                        }`}
                        onClick={() => handleTabChange("vehicles")}
                      >
                        Vehicles
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        className={`bg-transparent border-0 py-3 position-relative px-3 ${
                          activeTab == "assets" && "active"
                        }`}
                        onClick={() => handleTabChange("assets")}
                      >
                        Assets
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        className={`bg-transparent border-0 py-3 position-relative px-3 ${
                          activeTab == "incomeExpenseStatement" && "active"
                        }`}
                        onClick={() =>
                          handleTabChange("incomeExpenseStatement")
                        }
                      >
                        Income and Expense Statement
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        className={`bg-transparent border-0 py-3 position-relative px-3 ${
                          activeTab == "legal" && "active"
                        }`}
                        onClick={() => handleTabChange("legal")}
                      >
                        Legal
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        className={`bg-transparent border-0 py-3 position-relative px-3 ${
                          activeTab == "bankruptcy" && "active"
                        }`}
                        onClick={() => handleTabChange("bankruptcy")}
                      >
                        Bankruptcy
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>
                </div>
                <div className="bg-white px-4 py-3 card-box">
                  <Tab.Content>
                    <Tab.Pane
                      className={
                        activeTab == "personalInfo" ? "active show" : ""
                      }
                    >
                      <PersonalInfo data={MessageData?.personal_information} />
                    </Tab.Pane>

                    <Tab.Pane
                      className={activeTab == "legal" ? "active show" : ""}
                    >
                      <LeagalInfo data={MessageData?.legal || {}} />
                    </Tab.Pane>
                    <Tab.Pane
                      className={activeTab == "bankruptcy" ? "active show" : ""}
                    >
                      <BankruptcyInfo data={MessageData?.bankruptcy || {}} />
                    </Tab.Pane>
                    <Tab.Pane
                      className={activeTab == "empInfo" ? "active show" : ""}
                    >
                      <EmploymentInfo
                        data={MessageData?.employment_information}
                      />
                    </Tab.Pane>
                    <Tab.Pane
                      className={
                        activeTab == "otherFinancialInfo" ? "active show" : ""
                      }
                    >
                      <OtherFinancialInfo
                        data={MessageData?.other_finanical_information}
                      />{" "}
                    </Tab.Pane>
                    <Tab.Pane
                      className={
                        activeTab == "personalAssets" ? "active show" : ""
                      }
                    >
                      <PersonalAssets data={MessageData?.personal_assets} />{" "}
                    </Tab.Pane>
                    <Tab.Pane
                      className={
                        activeTab == "realPropertyOwned" ? "active show" : ""
                      }
                    >
                      <RealPropertyOwned
                        data={MessageData?.real_property_owned}
                      />
                    </Tab.Pane>
                    <Tab.Pane
                      className={activeTab == "vehicles" ? "active show" : ""}
                    >
                      <Vehicles
                        data={MessageData?.vehicles}
                        anotherData={MessageData?.another_vehicle_description}
                      />
                    </Tab.Pane>
                    <Tab.Pane
                      className={
                        activeTab == "incomeExpenseStatement"
                          ? "active show"
                          : ""
                      }
                    >
                      <IncomeExpenseStatement
                        // expensesInsurance={MessageData?.expenses_insurance}
                        incomeData={MessageData?.income}
                        expensesData={MessageData?.expenses}
                      />
                    </Tab.Pane>
                    <Tab.Pane
                      className={activeTab == "assets" ? "active show" : ""}
                    >
                      <Assets data={MessageData?.assets} />
                    </Tab.Pane>
                  </Tab.Content>
                </div>
              </Tab.Container>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};
export default ViewFinanceFormIndex;

// import React from "react";
// import PdfViewer from "./PdfViewer";

// const jsonData = {
//   name: "John Doe",
//   age: 30,
//   email: "john.doe@example.com",
// };

// // const ViewFinanceFormIndex = () => {
// //   return (
// //     <div>
// //       <h1>Personal Information PDF</h1>
// //       <PdfViewer jsonData={jsonData} />
// //     </div>
// //   );
// // };

// // export default ViewFinanceFormIndex;
